import { smartPushState } from "../vendor/evented-history-state-functions";
import {
	getHubBaseUrl,
	isHubPaginatedPage,
	setHubFilterUrl,
} from "../vendor/url-helper-functions";
import {
	fetchFilteredGridPosts,
	applyInstantClientFilter,
	newsCardTemplate,
	exitHubFilteredMode,
} from "./grid-filter-ajax";

(function($) {
	var $filterSelect = $("#filter-select");

	if (!$filterSelect.length) {
		return;
	}

	var isPaginatedHub = !!$filterSelect.data("paginated");

	function applyFilterFromUrlParam() {
		if (!isPaginatedHub || window.ldcHubFilterUrlApplied || isHubPaginatedPage()) {
			return;
		}

		var searchFilter = $.urlParam("filter");
		if (!searchFilter) {
			return;
		}

		var $option = $filterSelect.find("option").filter(function() {
			return $(this).val() === String(searchFilter);
		});
		if (!$option.length) {
			return;
		}

		window.ldcHubFilterUrlApplied = true;
		window.ldcSkipFilterUrlUpdate = true;
		$option.prop("selected", true).trigger("change");
	}

	$(document).ready(function() {
		if (isPaginatedHub) {
			exitHubFilteredMode();
			applyFilterFromUrlParam();
		}
	});

	$filterSelect.on("change", function() {
		var $this = $(this);
		var value = $this.val();
		var filterby = $this.find("option:selected").attr("data-filterby");

		if (!$filterSelect.data("paginated")) {
			var skipUrlUpdate = !!window.ldcSkipFilterUrlUpdate;
			window.ldcSkipFilterUrlUpdate = false;
			var $items = $(".grid-for-filtering .post__card, .filter-item");
			$items.removeClass("is-hidden");
			if (value !== "all") {
				$items.addClass("is-hidden");
				$items.each(function() {
					var terms = $(this).data(filterby);
					terms += " ";
					if (terms && terms.includes(" ")) {
						terms = terms.split(" ");
						if (terms.indexOf(value) != -1) {
							$(this).removeClass("is-hidden");
						}
					}
				});
			}
			if (value !== "all" && !skipUrlUpdate) {
				smartPushState(filterby, value, null, false, true);
			}
			return;
		}

		var skipUrlUpdate = !!window.ldcSkipFilterUrlUpdate;
		window.ldcSkipFilterUrlUpdate = false;

		var postType = $filterSelect.data("post-type");
		var $grid = $('.grid-for-filtering[data-post-type="' + postType + '"]');

		if (!postType) {
			postType = "post";
			$grid = $(".grid-for-filtering");
		}

		if (value === "all") {
			window.location.href = getHubBaseUrl();
			return;
		}

		if (!skipUrlUpdate) {
			setHubFilterUrl(value);
		}

		fetchFilteredGridPosts({
			postType: postType,
			term: value,
			taxonomy: filterby,
			filterby: filterby,
			value: value,
			$grid: $grid,
			instantFilter: false,
			cardTemplate: newsCardTemplate,
		});
	});
})(jQuery);
